import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const Insta: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="58" viewBox="0 0 59 58">
            <g id="Insta" transform="translate(-9574.309 -6042.478)">
                <g
                    id="Area_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_"
                    data-name="Area [SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]"
                    transform="translate(9574.309 6042.478)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="2"
                >
                    <rect width="59" height="58" rx="29" stroke="none" />
                    <rect x="1" y="1" width="57" height="56" rx="28" fill="none" />
                </g>
                <g
                    id="Icon_ICON_feather_instagram_SIZE_MEDIUM_STATE_DEFAULT_STYLE_STYLE2_"
                    data-name="Icon [ICON=feather/instagram][SIZE=MEDIUM][STATE=DEFAULT][STYLE=STYLE2]"
                    transform="translate(9591.346 6059.195)"
                >
                    <rect
                        id="Area_ICON:feather_instagram_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_"
                        data-name="Area [ICON:feather/instagram][SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]"
                        width="25"
                        height="24"
                        transform="translate(-0.037 0.282)"
                        fill="#fff"
                        opacity="0"
                    />
                    <g id="Icon" transform="translate(0)">
                        <rect
                            id="_61bb2ee3-a65a-49d7-b187-02f93257298a"
                            data-name="61bb2ee3-a65a-49d7-b187-02f93257298a"
                            width="25"
                            height="24"
                            rx="5"
                            transform="translate(-0.038 0.282)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                        <path
                            id="ebebc9d2-003e-4cbb-8f60-948f8d338a40"
                            d="M17.816,12.149A4.913,4.913,0,1,1,13.677,8.01,4.914,4.914,0,0,1,17.816,12.149Z"
                            transform="translate(-0.621 -0.641)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                        <line
                            id="_213a1441-3ee4-444f-9c62-722a3ab3a788"
                            data-name="213a1441-3ee4-444f-9c62-722a3ab3a788"
                            x2="0.012"
                            transform="translate(19.037 5.527)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(Insta);
